import React from 'react';
import { UsercentricsContext } from '../context.js';
import { useUsercentricsEventListener } from '../hooks/use-usercentrics-event-listener.js';
export const UsercentricsProvider = ({ children, strictMode = false, timeout }) => {
    const state = useUsercentricsEventListener({ timeout });
    return (React.createElement(UsercentricsContext.Provider, { value: {
            consents: state.consents,
            hasInteracted: state.hasInteracted,
            isClientSide: state.isClientSide,
            isFailed: state.isFailed,
            isInitialized: state.isInitialized,
            isOpen: state.isOpen,
            strictMode,
        } }, children));
};
